// Source
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelInvoice from "../../model/custom/Invoice";
import * as Instance from "../Instance";

export const uploadData = (formData: FormData, callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .post<ModelHelperSrc.Iresponse>("/invoice/upload_data", {}, formData)
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const uploadList = (dataMain: ModelInvoice.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        file_name: dataMain.file_name,
        client_id: dataMain.client_id as unknown as string,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/upload_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const createData = (
    detail: string,
    clientId: number,
    type: string,
    number: string,
    totalPaymentAmount: string,
    paymentDate: string,
    item: string | Record<string, unknown>,
    fileNumber: string,
    memo: string,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        detail,
        client_id: clientId,
        type,
        number,
        total_payment_amount: totalPaymentAmount,
        payment_date: paymentDate,
        item,
        file_number: fileNumber,
        memo
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/invoice/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (
    id: number,
    detail: string,
    clientId: number,
    type: string,
    number: string,
    totalPaymentAmount: string,
    paymentDate: string,
    item: string | Record<string, unknown>,
    fileNumber: string,
    memo: string,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        detail,
        client_id: clientId,
        type,
        number,
        total_payment_amount: totalPaymentAmount,
        payment_date: paymentDate,
        item,
        file_number: fileNumber,
        memo
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/invoice/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/invoice/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (typeValue: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        type: typeValue
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/invoice/validation_form",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelInvoice.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        file_name: dataMain.file_name,
        client_id: dataMain.client_id as unknown as string,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (mode: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        mode
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/select_option?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const invoiceOption = (id: number, clientId: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id: id as unknown as string,
        client_id: clientId as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/invoice_option?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const previewFile = (formData: FormData, callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .post<ModelHelperSrc.Iresponse>("/invoice/preview_file", {}, formData)
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const checkReview = (
    id: number,
    reviewerId: number | string,
    mode: string,
    reviewMetadata: Record<string, boolean>,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        reviewer_id: reviewerId,
        mode,
        review_metadata: reviewMetadata
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/invoice/check_review",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const payerDetail = (id: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/payer_detail?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const payeeDetail = (id: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/payee_detail?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const invoicePreparer = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id: id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/invoice/invoice_preparer?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
